"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ChangePasswordModal_1 = require("./ChangePasswordModal");
const react_i18next_1 = require("react-i18next");
exports.default = (0, react_i18next_1.withTranslation)('ChangePasswordModal')(ChangePasswordModal_1.ChangePasswordModal);
